import gql from 'graphql-tag';

export const DESELECT_POST_MALONE_SAVED_TEMPLATE_MUTATION = gql`
  mutation DeselectPostMaloneSavedTemplateMutation($campaignId: ID!, $postMaloneSavedTemplateId: ID!) {
    deselectPostMaloneSavedTemplate(campaignId: $campaignId, postMaloneSavedTemplateId: $postMaloneSavedTemplateId) {
      deletedId
      errors
    }
  }
`;
